import React, {Component} from 'react';
import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardMediaContent,
  CardAction,
  CardActionIcons,
  CardActions
} from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import { Elevation } from 'rmwc/Elevation';

export default class Result extends Component {
  render() {
    return(

      <div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Result/Result.js